import breakpoints from '../data/breakpoints';
import Slider from '../components/slider';
import enquire from 'enquire.js';

const slickoptions = {
    dots: true,
    arrows: false,
    fade: true,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: breakpoints.tablet - 1,
            settings: {
                slidesToShow: 2,
                fade: false,
                infinite: true,
                adaptiveHeight: false,
            }
        },
        {
            breakpoint: breakpoints.desktop - 1,
            settings: 'unslick'
        }
    ]
};

class News {
    constructor(el) {
        this.el = el;
        this.sliderEl = el.find('.slider');

        this.slider = new Slider(this.sliderEl, slickoptions);

        /**
     * Events
     */
        enquire.register('screen and (min-width: ' + breakpoints.desktop + 'px)', {
            unmatch: () => {
                if(!this.slider.slick.hasClass('slick-initialized')){
                    this.slider.slick.slick(slickoptions);
                }
            }
        });
    }
}

export default News;